import { Component, OnInit } from '@angular/core';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-modal-windrichtung-wert-anzeigen',
  templateUrl: './modal-windrichtung-wert-anzeigen.component.html',
  styleUrls: ['./modal-windrichtung-wert-anzeigen.component.css']
})
export class ModalWindrichtungWertAnzeigenComponent implements OnInit {

  windhaeufigkeitSumme: string = this.localService.mainComponentRef.value.windhaeufigkeitSumme;

  constructor(private localService: LocalService) { }

  ngOnInit(): void {
  }

}
